"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormFieldMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _ButtonGroup = require("../../components/ButtonGroup/ButtonGroup.styles");
var _FormHelp = require("../../components/FormHelp/FormHelp.styles");
var _Label = require("../../components/Label/Label.styles");
var _LabeledControl = require("../../components/LabeledControl/LabeledControl.styles");
var _spaceMixin = require("../spaceMixin");
var _spacingMixin = require("../spacingMixin");
/** @class FormFieldMixin */
/** @method */
var FormFieldMixin = function FormFieldMixin(props) {
  return (0, _styledToken.default)({
    labelPaddingBottom: 'FormField.Label.paddingBottom',
    helpMarginTop: 'FormField.Help.marginTop',
    labeledControlMarginLeft: 'FormField.LabeledControl.marginLeft',
    buttonGroupMarginTop: 'FormField.ButtonGroup.marginTop'
  }, function (_ref) {
    var labelPaddingBottom = _ref.labelPaddingBottom,
      helpMarginTop = _ref.helpMarginTop,
      labeledControlMarginLeft = _ref.labeledControlMarginLeft,
      buttonGroupMarginTop = _ref.buttonGroupMarginTop;
    return (0, _styledComponents.css)(["> ", "{display:block;padding-bottom:", ";}> ", "{margin-top:", ";}> ", "{margin-left:", ";}> ", "{margin-top:", ";}border:0;padding:0;margin:0;", ""], _Label.StyledLabel, labelPaddingBottom ? labelPaddingBottom + "px" : (0, _spaceMixin.spaceMixin)(0.5)(props), _FormHelp.StyledFormHelp, helpMarginTop ? helpMarginTop + "px" : (0, _spaceMixin.spaceMixin)(0.5)(props), _LabeledControl.StyledLabeledControl, labeledControlMarginLeft ? labeledControlMarginLeft + "px" : (0, _spaceMixin.spaceMixin)('xs')(props), _ButtonGroup.StyledButtonGroup, buttonGroupMarginTop ? buttonGroupMarginTop + "px" : (0, _spaceMixin.spaceMixin)('xs')(props), (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.FormFieldMixin = FormFieldMixin;